import styled from 'styled-components';

export const Container = styled.div`
  .react-json-view {
    border: 1px solid ${({ theme }) => theme.colors.semantic.border.default} !important;
    border-radius: 8px;
    overflow: auto;
    padding: 12px;
    background-color: ${({ theme }) =>
      theme.colors.semantic.surface.card} !important;
  }

  div.click-to-edit,
  .click-to-remove {
    display: inline;
  }
`;
